import audio1 from 'assets/sounds/adult/ordiktatSounds/nn/1-godt.mp3';
import audio2 from 'assets/sounds/adult/ordiktatSounds/nn/2-aldri.mp3';
import audio3 from 'assets/sounds/adult/ordiktatSounds/nn/3-kanskje.mp3';
import audio4 from 'assets/sounds/adult/ordiktatSounds/nn/4-vore.mp3';
import audio5 from 'assets/sounds/adult/ordiktatSounds/nn/5-fullt.mp3';
import audio6 from 'assets/sounds/adult/ordiktatSounds/nn/6-love.mp3';
import audio7 from 'assets/sounds/adult/ordiktatSounds/nn/7-kvart.mp3';
import audio8 from 'assets/sounds/adult/ordiktatSounds/nn/8-trygt.mp3';
import audio9 from 'assets/sounds/adult/ordiktatSounds/nn/9-fylt.mp3';
import audio10 from 'assets/sounds/adult/ordiktatSounds/nn/10-sjeldan.mp3';
import audio11 from 'assets/sounds/adult/ordiktatSounds/nn/11-ungomsskole.mp3';
import audio12 from 'assets/sounds/adult/ordiktatSounds/nn/12-adresse.mp3';
import audio13 from 'assets/sounds/adult/ordiktatSounds/nn/13-kirurgi.mp3';
import audio14 from 'assets/sounds/adult/ordiktatSounds/nn/14-vert.mp3';
import audio15 from 'assets/sounds/adult/ordiktatSounds/nn/15-bnner.mp3';
import audio16 from 'assets/sounds/adult/ordiktatSounds/nn/16-aggressiv.mp3';
import audio17 from 'assets/sounds/adult/ordiktatSounds/nn/17-konkurranse.mp3';
import audio18 from 'assets/sounds/adult/ordiktatSounds/nn/18-sjlvsagt.mp3';
import audio19 from 'assets/sounds/adult/ordiktatSounds/nn/19-rettssak.mp3';
import audio20 from 'assets/sounds/adult/ordiktatSounds/nn/20-dessverre.mp3';
import audio21 from 'assets/sounds/adult/ordiktatSounds/nn/21-herleg.mp3';
import audio22 from 'assets/sounds/adult/ordiktatSounds/nn/22-elleve.mp3';
import audio23 from 'assets/sounds/adult/ordiktatSounds/nn/23-skylje.mp3';
import audio24 from 'assets/sounds/adult/ordiktatSounds/nn/24-lave.mp3';
import audio25 from 'assets/sounds/adult/ordiktatSounds/nn/25-meteorolog.mp3';
import audio26 from 'assets/sounds/adult/ordiktatSounds/nn/26-nysgjerrig.mp3';
import audio27 from 'assets/sounds/adult/ordiktatSounds/nn/27-skylde.mp3';
import audio28 from 'assets/sounds/adult/ordiktatSounds/nn/28-skikkeleg.mp3';
import audio29 from 'assets/sounds/adult/ordiktatSounds/nn/29-verdt.mp3';
import audio30 from 'assets/sounds/adult/ordiktatSounds/nn/30-Hrverk.mp3';
import audio31 from 'assets/sounds/adult/ordiktatSounds/nn/31-arrangement.mp3';
import audio32 from 'assets/sounds/adult/ordiktatSounds/nn/32-bnder.mp3';
import audio33 from 'assets/sounds/adult/ordiktatSounds/nn/33-giftige.mp3';
import audio34 from 'assets/sounds/adult/ordiktatSounds/nn/34-transporttenester.mp3';
import audio35 from 'assets/sounds/adult/ordiktatSounds/nn/35-brekraftstrategi.mp3';

const audioFiles = {
	1: audio1,
	2: audio2,
	3: audio3,
	4: audio4,
	5: audio5,
	6: audio6,
	7: audio7,
	8: audio8,
	9: audio9,
	10: audio10,
	11: audio11,
	12: audio12,
	13: audio13,
	14: audio14,
	15: audio15,
	16: audio16,
	17: audio17,
	18: audio18,
	19: audio19,
	20: audio20,
	21: audio21,
	22: audio22,
	23: audio23,
	24: audio24,
	25: audio25,
	26: audio26,
	27: audio27,
	28: audio28,
	29: audio29,
	30: audio30,
	31: audio31,
	32: audio32,
	33: audio33,
	34: audio34,
	35: audio35,
};

export default audioFiles;
